import type { FaireProductEntity } from "../../entity_types/product";

export const p_285m22ayad: FaireProductEntity = {
  token: "p_285m22ayad",
  type: "product",
  name: "Moroccan Visage Mug",
  brandToken: "b_6xvu4qtx",
  brandName: "Verve Culture",
  imageUrl:
    "https://cdn.faire.com/fastly/65a0f101831e3a4a45cdab032f257780cd930202af3923f1cb56594555bc40cc.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/a0b3b4cdf15fea7c6202f583417a0af9974b75bf6f86e9dddaf61e85700dde45.jpeg",
    "https://cdn.faire.com/fastly/8bc2b056e9002df773e52ed7b491df81841acf5c2e6bc29f9ff436fed4b4cb38.jpeg",
    "https://cdn.faire.com/fastly/80aea184aadcba27c89e3cb8f5fbd23133b1512e2d4fd0c6dec269d795455a24.jpeg",
    "https://cdn.faire.com/fastly/c82f458bf21650bec632e0bbff0eb5872bc48c843380668e031f14dd5c42a383.jpeg",
  ],
  priceDollars: 15,
  description:
    "This unique ceramic mug from Morocco combines artisanal craftsmanship with modern artistry. Handmade and hand-painted by skilled Moroccan artisans, each mug features a one-of-a-kind abstract face design that adds a touch of contemporary elegance to your daily routine. With its smooth ceramic finish and distinctive lines, this mug is as functional as it is expressive — perfect for enjoying coffee, tea, or simply displaying as a decorative accent in your kitchen or home.\n\nBring a piece of Morocco’s vibrant culture and artistic spirit into your space with this beautifully crafted and expressive mug.\n\nDue to the handmade nature of this piece, slight variations in color, shape, and design are to be expected and celebrated.",
  tags: [],
  msrpDollars: 30,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-04-05T16:54:20.587Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
